import Layout from '@/views/layout/Layout'
import RouteView from '@/views/layout/RouteView'
 
 const personnelRoutes = {
  path: '/personnel',
  component: Layout,
  redirect: '/personnel/accountPermission/users',
  defaultPath: '/personnel/accountPermission/users',
  name: 'personnel',
  meta: {title: '组织与权限', icon: 'personnel'},
  children: [
    {
      path: 'personnelManager',
      name: 'personnelManager',
      component: () => import('@/views/personnelManager/index'),
      meta: {title: '组织人事', icon: 'personnelManager'},
      children: [
        {
          path: 'departMentInfo',
          name: 'departMentInfo',
          morePath: '/personnel/personnelManager/departMentInfo',
          component: () => import('@/views/personnelManager/departMentInfo/index'),
          meta: {title: '部门管理', icon: 'personnelManager'}
        },
        {
          path: 'staffManagerUserOld',
          name: 'staffManagerUserOld',
          morePath: '/personnel/personnelManager/staffManagerUserOld',
          component: () => import('@/views/staffManager/indexOld'),
          meta: {title: '人员管理', icon: 'personnelManager'}
        },
        {
          path: 'performanceInfo',
          name: 'performanceInfo',
          morePath: '/personnel/personnelManager/performanceInfo',
          component: () => import('@/views/personnelManager/performanceInfo/index'),
          meta: {title: '绩效模版', icon: 'personnelManager'}
        },
        {
          path: 'CreatePerformance',
          name: 'CreatePerformance',
          morePath: '/personnel/personnelManager/CreatePerformance',
          component: () => import('@/views/personnelManager/performanceInfo/components/CreatePerformance'),
          meta: {title: '创建绩效模版', icon: 'personnelManager'},
          hidden: true
        },
        {
          path: 'UpdatePerformance',
          name: 'UpdatePerformance',
          morePath: '/personnel/personnelManager/UpdatePerformance',
          component: () => import('@/views/personnelManager/performanceInfo/components/UpdatePerformance'),
          meta: {title: '修改绩效模版', icon: 'personnelManager'},
          hidden: true
        },
        {
          path: 'myPerformanceInfo',
          name: 'myPerformanceInfo',
          morePath: '/personnel/personnelManager/myPerformanceInfo',
          component: () => import('@/views/personnelManager/myPerformanceInfo/index'),
          meta: {title: '我的绩效', icon: 'personnelManager'}
        },

        {
          path: 'PerformanceDetail',
          name: 'PerformanceDetail',
          morePath: '/personnel/personnelManager/PerformanceDetail',
          component: () => import('@/views/personnelManager/myPerformanceInfo/components/PerformanceDetail'),
          meta: {title: '我的绩效详情', icon: 'personnelManager'},
          hidden: true
        },

        {
          path: 'performanceInfoScore',
          name: 'performanceInfoScore',
          morePath: '/personnel/personnelManager/performanceInfoScore',
          component: () => import('@/views/personnelManager/performanceInfoScore/index'),
          meta: {title: '绩效评分', icon: 'personnelManager'}
        },
         {
          path: 'PerformanceScoreDetail',
          name: 'PerformanceScoreDetail',
          morePath: '/personnel/personnelManager/PerformanceScoreDetail',
          component: () => import('@/views/personnelManager/performanceInfoScore/components/PerformanceScoreDetail'),
          meta: {title: '绩效评分详情', icon: 'personnelManager'},
          hidden: true
        },

        {
          path: 'performanceInfoReviewScore',
          name: 'performanceInfoReviewScore',
          morePath: '/personnel/personnelManager/performanceInfoReviewScore',
          component: () => import('@/views/personnelManager/performanceInfoReviewScore/index'),
          meta: {title: '绩效复核', icon: 'personnelManager'}
        },

         {
          path: 'PerformanceReviewScoreDetail',
          name: 'PerformanceReviewScoreDetail',
          morePath: '/personnel/personnelManager/PerformanceReviewScoreDetail',
          component: () => import('@/views/personnelManager/performanceInfoReviewScore/components/PerformanceReviewScoreDetail'),
          meta: {title: '绩效复核详情', icon: 'personnelManager'},
          hidden: true
        },




        /* {
          path: 'performanceInfoConfirm',
          name: 'performanceInfoConfirm',
          morePath: '/personnel/personnelManager/performanceInfoConfirm',
          component: () => import('@/views/personnelManager/performanceInfoConfirm/index'),
          meta: {title: '绩效确认', icon: 'personnelManager'}
        },

         {
          path: 'PerformanceConfirmDetail',
          name: 'PerformanceConfirmDetail',
          morePath: '/personnel/personnelManager/PerformanceConfirmDetail',
          component: () => import('@/views/personnelManager/performanceInfoConfirm/components/PerformanceConfirmDetail'),
          meta: {title: '绩效确认详情', icon: 'personnelManager'},
          hidden: true
        }, */


         {
          path: 'performanceInfoStatistics',
          name: 'performanceInfoStatistics',
          morePath: '/personnel/personnelManager/performanceInfoStatistics',
          component: () => import('@/views/personnelManager/performanceInfoStatistics/index'),
          meta: {title: '绩效统计', icon: 'personnelManager'}
        },


        {
          path: 'PerformanceInfoStatisticsDetail',
          name: 'PerformanceInfoStatisticsDetail',
          morePath: '/personnel/personnelManager/PerformanceInfoStatisticsDetail',
          component: () => import('@/views/personnelManager/performanceInfoStatistics/components/PerformanceInfoStatisticsDetail'),
          meta: {title: '绩效统计详情', icon: 'personnelManager'},
          hidden: true
        },


        /* {
          path: 'performanceInfoManager',
          name: 'performanceInfoManager',
          morePath: '/personnel/personnelManager/performanceInfoManager',
          component: () => import('@/views/personnelManager/performanceInfoManager/index'),
          meta: {title: '绩效管理', icon: 'personnelManager'}
        },

        {
          path: 'PerformanceManagerDetail',
          name: 'PerformanceManagerDetail',
          morePath: '/personnel/personnelManager/PerformanceManagerDetail',
          component: () => import('@/views/personnelManager/performanceInfoManager/components/PerformanceManagerDetail'),
          meta: {title: '绩效管理详情', icon: 'personnelManager'},
          hidden: true
        }, */
        {
          path: 'staffManager',
          name: 'staffManager',
          morePath: '/personnel/personnelManager/staffManager',
          component: () => import('@/views/staffManager/index'),
          meta: {title: '员工管理', icon: 'personnelManager'}
        },
        {
          path: 'staffDetail',
          name: 'staffDetail',
          morePath: '/personnel/personnelManager/staffDetail',
          component: () => import('@/views/staffManager/detail'),
          meta: {title: '员工详情'},
          hidden: true
        },

        {
          path: 'monthlyAttendance',
          name: 'monthlyAttendance',
          morePath: '/personnel/personnelManager/monthlyAttendance',
          component: () => import('@/views/personnelManager/monthlyAttendance/index'),
          meta: {title: '月度考勤', icon: 'personnelManager'}
        },
        {
          path: 'attendanceDetails',
          name: 'attendanceDetails',
          morePath: '/personnel/personnelManager/attendanceDetails',
          component: () => import('@/views/personnelManager/attendanceDetails/index'),
          meta: {title: '出勤明细', icon: 'personnelManager'}
        },
        {
          path: 'salaryList',
          name: 'salaryList',
          morePath: '/personnel/personnelManager/salaryList',
          component: () => import('@/views/personnelManager/salaryList/index'),
          meta: {title: '工资列表', icon: 'personnelManager'}
        }

      ]
    },
    {
      path: 'ums',
      name: 'ums',
      component: () => import('@/views/permission/index'),
      meta: {title: '权限配置', icon: 'ums-admin'},
      children: [
        {
          path: 'admin',
          morePath: '/personnel/ums/admin',
          name: 'admin',
          component: () => import('@/views/ums/admin/index'),
          meta: {title: '用户列表', icon: 'ums-admin'}
        },
        {
          path: 'role',
          morePath: '/personnel/ums/role',
          name: 'role',
          component: () => import('@/views/ums/role/index'),
          meta: {title: '角色列表', icon: 'ums-role'}
        },
        {
          path: 'organizationDepartment',
          morePath: '/personnel/ums/organizationDepartment',
          name: 'organizationDepartment',
          component: () => import('@/views/ums/department/index'),
          meta: {title: '部门管理', icon: 'ums-admin'}
        },
        {
          path: 'reminderRecipientConfig',
          morePath: '/personnel/ums/reminderRecipientConfig',
          name: 'reminderRecipientConfig',
          component: () => import('@/views/ums/reminderRecipientConfig/index'),
          meta: {title: '提醒配置', icon: 'ums-admin'}
        },
        {
          path: 'businessPeople',
          morePath: '/personnel/ums/businessPeople',
          name: 'businessPeople',
          component: () => import('@/views/ums/businessPeople/index'),
          meta: {title: '商务人员', icon: 'ums-admin'}
        },
        {
          path: 'allocMenu',
          morePath: '/personnel/ums/allocMenu',
          name: 'allocMenu',
          component: () => import('@/views/ums/role/allocMenu'),
          meta: {title: '分配菜单'},
          hidden: true
        },
        /* {
          path: 'menu',
          name: 'menu',
          morePath: '/personnel/ums/menu',
          component: () => import('@/views/ums/menu/index'),
          meta: {title: '菜单列表', icon: 'ums-menu'}
        },
        {
          path: 'updateMenu',
          name: 'updateMenu',
          component: () => import('@/views/ums/menu/update'),
          meta: {title: '修改菜单'},
          hidden: true
        },
        {
          path: 'addMenu',
          name: 'addMenu',
          component: () => import('@/views/ums/menu/add'),
          meta: {title: '添加菜单'},
          hidden: true
        } */
      ]
    }
  ]
}

const permissionIndex = personnelRoutes.children.findIndex(route => route.name === 'ums')
if (permissionIndex !== -1) {
  const permissionRoot = personnelRoutes.children[permissionIndex]
  const routeByName = name => permissionRoot.children.find(route => route.name === name)
  const movedRoute = (name, path, alias, morePath, title) => Object.assign({}, routeByName(name), {
    path,
    alias,
    morePath,
    meta: Object.assign({}, routeByName(name).meta, { title })
  })
  personnelRoutes.children.splice(permissionIndex, 1,
    {
      path: 'accountPermission',
      name: 'accountPermission',
      component: RouteView,
      meta: { title: '账号与权限', icon: 'ums-admin' },
      children: [
        movedRoute('admin', 'users', '/personnel/ums/admin', '/personnel/accountPermission/users', '用户管理'),
        movedRoute('role', 'roles', '/personnel/ums/role', '/personnel/accountPermission/roles', '角色管理'),
        movedRoute('allocMenu', 'allocMenu', '/personnel/ums/allocMenu', '/personnel/accountPermission/allocMenu', '分配菜单')
      ]
    },
    {
      path: 'organizationConfig',
      name: 'organizationConfig',
      component: RouteView,
      meta: { title: '组织配置', icon: 'personnel' },
      children: [
        movedRoute('organizationDepartment', 'departments', '/personnel/ums/organizationDepartment', '/personnel/organizationConfig/departments', '部门管理'),
        movedRoute('businessPeople', 'businessPeople', '/personnel/ums/businessPeople', '/personnel/organizationConfig/businessPeople', '商务人员')
      ]
    },
    {
      path: 'systemConfig',
      name: 'systemConfig',
      component: RouteView,
      meta: { title: '系统配置', icon: 'ums-admin' },
      children: [
        movedRoute('reminderRecipientConfig', 'reminders', '/personnel/ums/reminderRecipientConfig', '/personnel/systemConfig/reminders', '提醒配置')
      ]
    })
}

export default personnelRoutes



// WEBPACK FOOTER //
// ./src/router/personnel.js